<template>
  <div class="fancy-next" :class="{ '-grey': isGrey }">
    <icon-next />
  </div>
</template>

<script>
export default {
  props: {
    isGrey: {
      type: Boolean,
      default: false
    }
  }
}
</script>